module.exports = __webpack_public_path__ + "media/images/new/icons/calendar2-3bf1c778f95fea678258783e7d010703.png";